"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetSourceType = exports.AssetVerificationDocumentType = exports.AssetType = exports.AssetEntryType = exports.doesAssetTypeSupportAddCoApplicantOnDtiFailure = exports.HELOC_ASSET_TYPES = exports.isHelocAssetType = exports.HOME_ASSET_TYPES = exports.isHomeAssetType = exports.LOAN_ASSET_TYPES_USING_LOAN_APPLICATION_ENTITY = exports.ASSET_TYPE_TO_SAME_ASSET_TYPE_GROUP_MAP = exports.ASSET_TYPE_TO_GROUP_KEY = exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES = exports.AssetTypeGroupKey = exports.LoanAssetType = void 0;
const assertUtils_1 = require("../assertUtils");
/** @TranslateToPython @TranslateToEnum @TranslateToRust */
var LoanAssetType;
(function (LoanAssetType) {
    LoanAssetType["home"] = "home";
    LoanAssetType["home_no_loyalty"] = "home_no_loyalty";
    LoanAssetType["crypto"] = "crypto";
    LoanAssetType["auto"] = "auto";
    LoanAssetType["personalPropertyAttestation"] = "personalPropertyAttestation";
    LoanAssetType["homeMortgage"] = "homeMortgage";
    LoanAssetType["deposit"] = "deposit";
})(LoanAssetType || (exports.LoanAssetType = LoanAssetType = {}));
var AssetTypeGroupKey;
(function (AssetTypeGroupKey) {
    AssetTypeGroupKey["home"] = "home";
    AssetTypeGroupKey["personalPropertyAttestation"] = "personalPropertyAttestation";
    AssetTypeGroupKey["crypto"] = "crypto";
    AssetTypeGroupKey["auto"] = "auto";
    AssetTypeGroupKey["deposit"] = "deposit";
    AssetTypeGroupKey["homeMortgage"] = "homeMortgage";
})(AssetTypeGroupKey || (exports.AssetTypeGroupKey = AssetTypeGroupKey = {}));
exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES = {
    [AssetTypeGroupKey.home]: [LoanAssetType.home, LoanAssetType.home_no_loyalty],
    [AssetTypeGroupKey.personalPropertyAttestation]: [LoanAssetType.personalPropertyAttestation],
    [AssetTypeGroupKey.crypto]: [LoanAssetType.crypto],
    [AssetTypeGroupKey.auto]: [LoanAssetType.auto],
    [AssetTypeGroupKey.deposit]: [LoanAssetType.deposit],
    [AssetTypeGroupKey.homeMortgage]: [LoanAssetType.homeMortgage],
};
exports.ASSET_TYPE_TO_GROUP_KEY = {
    [LoanAssetType.home]: AssetTypeGroupKey.home,
    [LoanAssetType.home_no_loyalty]: AssetTypeGroupKey.home,
    [LoanAssetType.homeMortgage]: AssetTypeGroupKey.homeMortgage,
    [LoanAssetType.personalPropertyAttestation]: AssetTypeGroupKey.personalPropertyAttestation,
    [LoanAssetType.crypto]: AssetTypeGroupKey.crypto,
    [LoanAssetType.auto]: AssetTypeGroupKey.auto,
    [LoanAssetType.deposit]: AssetTypeGroupKey.deposit,
};
// Prevent customers from opening multiple accounts of the same group, i.e. no home + home_no_loyalty account
exports.ASSET_TYPE_TO_SAME_ASSET_TYPE_GROUP_MAP = {
    [LoanAssetType.home]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.home]],
    [LoanAssetType.home_no_loyalty]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.home_no_loyalty]],
    [LoanAssetType.homeMortgage]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.homeMortgage]],
    [LoanAssetType.personalPropertyAttestation]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.personalPropertyAttestation]],
    [LoanAssetType.crypto]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.crypto]],
    [LoanAssetType.auto]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.auto]],
    [LoanAssetType.deposit]: exports.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[exports.ASSET_TYPE_TO_GROUP_KEY[LoanAssetType.deposit]],
};
exports.LOAN_ASSET_TYPES_USING_LOAN_APPLICATION_ENTITY = [
    LoanAssetType.home,
    LoanAssetType.home_no_loyalty,
    LoanAssetType.personalPropertyAttestation,
    LoanAssetType.homeMortgage,
    LoanAssetType.deposit,
];
const isHomeAssetType = (assetType) => {
    switch (assetType) {
        case LoanAssetType.home:
        case LoanAssetType.home_no_loyalty:
        case LoanAssetType.homeMortgage:
            return true;
        case LoanAssetType.personalPropertyAttestation:
        case LoanAssetType.crypto:
        case LoanAssetType.auto:
        case LoanAssetType.deposit:
            return false;
        default:
            return (0, assertUtils_1.assertNever)(assetType, `Unexpected asset type: ${assetType}`);
    }
};
exports.isHomeAssetType = isHomeAssetType;
exports.HOME_ASSET_TYPES = Object.values(LoanAssetType).filter(exports.isHomeAssetType);
/**
 * Narrows an asset type to a HELOC (home-equity line) product for purchase-specific inputs.
 * Unlike {@link isHomeAssetType}, this excludes `homeMortgage` (a first-lien product).
 * The TX soft-launch channel gate applies to HELOC origination only, not mortgages.
 */
const isHelocAssetType = (assetType) => {
    switch (assetType) {
        case LoanAssetType.home:
        case LoanAssetType.home_no_loyalty:
            return true;
        case LoanAssetType.homeMortgage:
        case LoanAssetType.personalPropertyAttestation:
        case LoanAssetType.crypto:
        case LoanAssetType.auto:
        case LoanAssetType.deposit:
            return false;
        default:
            return (0, assertUtils_1.assertNever)(assetType, `Unexpected asset type: ${assetType}`);
    }
};
exports.isHelocAssetType = isHelocAssetType;
exports.HELOC_ASSET_TYPES = Object.values(LoanAssetType).filter(exports.isHelocAssetType);
/**
 * Whether this asset type's UW pipeline assigns `deniedIndividualCanAddCoApplicant` on a
 * DTI-only-solo denial — the gate on offering the FE add-coApplicant recovery flow.
 *
 * Returns false for UCC, mortgage, auto, crypto, deposit. UCC and mortgage do support
 * co-applicants via their own joint-application flows, just not via DTI-failure recovery,
 * so callers asking "can this product attach a coapp at all" should reach for a
 * product-specific predicate, not this one.
 */
const doesAssetTypeSupportAddCoApplicantOnDtiFailure = (assetType) => {
    switch (assetType) {
        case LoanAssetType.home:
        case LoanAssetType.home_no_loyalty:
            return true;
        case LoanAssetType.personalPropertyAttestation:
        case LoanAssetType.crypto:
        case LoanAssetType.auto:
        case LoanAssetType.homeMortgage:
        case LoanAssetType.deposit:
            return false;
        default:
            (0, assertUtils_1.assertNever)(assetType, `Unexpected asset type: ${assetType}`);
    }
};
exports.doesAssetTypeSupportAddCoApplicantOnDtiFailure = doesAssetTypeSupportAddCoApplicantOnDtiFailure;
var AssetEntryType;
(function (AssetEntryType) {
    AssetEntryType["STATED_ANNUAL_RENEWAL_RESERVES"] = "STATED_ANNUAL_RENEWAL_RESERVES";
    AssetEntryType["STATED_LIQUID_ASSET_RESERVES"] = "STATED_LIQUID_ASSET_RESERVES";
})(AssetEntryType || (exports.AssetEntryType = AssetEntryType = {}));
var AssetType;
(function (AssetType) {
    AssetType["RESERVES"] = "RESERVES";
})(AssetType || (exports.AssetType = AssetType = {}));
var AssetVerificationDocumentType;
(function (AssetVerificationDocumentType) {
    AssetVerificationDocumentType["BANK_STATEMENT"] = "BANK_STATEMENT";
})(AssetVerificationDocumentType || (exports.AssetVerificationDocumentType = AssetVerificationDocumentType = {}));
var AssetSourceType;
(function (AssetSourceType) {
    AssetSourceType["TOTAL"] = "TOTAL";
})(AssetSourceType || (exports.AssetSourceType = AssetSourceType = {}));
